export default __webpack_public_path__ + "static/SRUS SBP205 - Especification Del Producto y Datos Técnicos-bf10e8e58a1c8d375f6f79496972c780.pdf";